import commonDataAccess from "../commonDataAccess";

export interface TastePanelDetail {
  id: number | string;
  organizationId: number;
  sequencePosition?: number;
  lotCode?: string;
  bestBefore?: string;
  lab?: string;
  colour?: string;
  tastePanelId: number;
  ph?: string;
  viscosity?: number;
  flavour?: string;
  texture?: string;
  appearance?: string;
  weight?: number;
  testDate?: string;
  result?: string;
  specialAction?: string;
  status?: string;
  logStatus?: string;
  techInit?: string;
  comments?: string;
  trialId?: string;
}

export enum LabType {
  Y = "Y",
  L = "L",
}

export enum Evaluation {
  Acceptable = "Acceptable",
  Rejectable = "Rejectable",
  Improveable = "Improveable",
}

export enum ResultType {
  Pass = "Pass",
  PassImproveable = "Pass/Improveable",
  Fail = "Fail",
}

export enum SpecialActionType {
  Hold14DVT = "Hold14DVT",
  Hold14TEC = "Hold14TEC",
  PartRelease = "PartRelease",
}

export enum StatusType {
  Release = "Released",
  Investigate = "Investigate",
  Hold = "Hold",
  Rework = "Rework",
  Reject = "Rejected",
  NPDSignoff = "NPDSignOff",
}

export enum TrialType {
  Y = "Y",
  T = "T",
}

export const enumToOptions = <T extends Record<string, string>>(enumObj: T) =>
  Object.values(enumObj).map((v) => ({ label: v, value: v }));

class TastePanelDetailDataAccess {
  getByTastePanelId = (
    tastePanelId: number | string
  ): Promise<{ success: boolean; data: TastePanelDetail[] }> => {
    return commonDataAccess.getData(
      `tastepaneldetail/getByTastePanelId/${tastePanelId}`
    );
  };

  deleteTastePanelDetail = (
    id: number | string
  ): Promise<{ success: boolean; message: string }> => {
    return commonDataAccess.deleteData(`tastepaneldetail/${id}`);
  };

  saveTastePanelDetails = (
    details: TastePanelDetail[]
  ): Promise<{ success: boolean; data: any }> => {
    return commonDataAccess.postData("tastepaneldetail/save", details);
  };
}

export default new TastePanelDetailDataAccess();
